import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Container } from "@mui/material";

const BlogPage = () => {
    const { slug } = useParams();
    const [content, setContent] = useState("");

    useEffect(() => {
        import(`../../../public/blogs/${slug}.md`)
            .then((file) => {
                fetch(file.default)
                    .then((response) => response.text())
                    .then((text) => setContent(text))
                    .catch((err) => console.error(err));
            })
            .catch((err) =>
                console.error(`Markdown file not found: ${slug}`, err)
            );
    }, [slug]);
    console.log("On Blog!");
    return (
        <Container className="markdown-content">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </Container>
    );
};

export default BlogPage;
